if (!customElements.get('ff-compliance-center')) {
  customElements.define('ff-compliance-center', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const search = this.querySelector('[data-search]');
      const model = this.querySelector('[data-model]');
      const category = this.querySelector('[data-category]');
      const documents = [...this.querySelectorAll('[data-document]')];
      const choices = [...this.querySelectorAll('[data-model-choice]')];
      const count = this.querySelector('[data-count]');
      const normalize = value => value.toLowerCase().replace(/[^a-z0-9]/g, '');
      const update = () => {
        const query = normalize(search.value);
        let visible = 0;
        documents.forEach(doc => {
          const show = (!model.value || doc.dataset.model.split(',').map(v => v.trim()).includes(model.value)) && (!category.value || doc.dataset.category === category.value) && (!query || normalize(doc.textContent).includes(query));
          doc.hidden = !show;
          if (show) visible++;
        });
        choices.forEach(choice => choice.setAttribute('aria-current', String(choice.dataset.modelChoice === model.value)));
        count.textContent = `${visible} document${visible === 1 ? '' : 's'}${model.value ? ` for ${model.value}` : ''}`;
        this.querySelector('[data-empty]').hidden = visible !== 0;
      };
      search.addEventListener('input', update);
      model.addEventListener('change', update);
      category.addEventListener('change', update);
      choices.forEach(choice => choice.addEventListener('click', () => {
        model.value = choice.dataset.modelChoice;
        category.value = '';
        search.value = '';
        update();
      }));
      this.querySelector('[data-reset]').addEventListener('click', () => {
        search.value = ''; model.value = ''; category.value = ''; update(); search.focus();
      });
      this.querySelector('[data-filters]').hidden = false;
      update();
    }
  });
}
